export const MIN_NB_OF_WEEKS_TO_GROUP_WEEKS = 10;
// Avant on avait 7 car en France c'est jamais 8
// Mais à l'ile Maurice ça peut être 8
// Mais en fait on introduit un colonne vide pour tous ceux en métropole
// du conp c'est chiant donc rollback à 8
export const DEFAULT_NB_OF_WEEKS_PER_LINE = 7;
